import { useEffect, useState } from 'react';
import { Modal, Box, Typography, TextField, Button } from '@mui/material';

const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 400,
    bgcolor: 'background.paper',
    borderRadius: 2,
    boxShadow: 24,
    p: 4,
};

export default function RechazoModal({
    open,
    onClose,
    onSubmit,
    isEditing,
    row,
}) {
    const [observacion, setObservacion] = useState('');

    useEffect(() => {
        if (!isEditing) {
            setObservacion(row?.observacion || '');
        } else {
            setObservacion('');
        }
    }, [isEditing, row?.observacion]);

    const handleChange = (e) => {
        const value = e.target.value;
        if (value.length <= 255) {
            setObservacion(value);
        }
    };

    const handleSubmit = () => {
        onSubmit(observacion);
        setObservacion('');
        onClose();
    };

    return (
        <Modal open={open} onClose={onClose}>
            <Box sx={style}>
                <Typography variant="h6" mb={2}>
                    Observación del Rechazo
                </Typography>
                <TextField
                    label="Observación"
                    multiline
                    rows={4}
                    fullWidth
                    value={observacion}
                    onChange={handleChange}
                    helperText={`${observacion.length}/255`}
                    InputProps={{ readOnly: !isEditing ? true : false }}
                />
                {isEditing && (
                    <Box
                        mt={2}
                        display="flex"
                        justifyContent="flex-end"
                        gap={1}
                    >
                        <Button onClick={onClose} variant="outlined">
                            Cancelar
                        </Button>
                        <Button
                            onClick={handleSubmit}
                            variant="contained"
                            disabled={observacion.trim() === ''}
                        >
                            Confirmar
                        </Button>
                    </Box>
                )}
            </Box>
        </Modal>
    );
}
